import { render } from "./Aside.vue?vue&type=template&id=30d0e612"
import script from "./Aside.vue?vue&type=script&lang=ts"
export * from "./Aside.vue?vue&type=script&lang=ts"
script.render = render

export default script